import React, { useEffect, useRef, useState } from 'react'
import { RadioButton } from 'primereact/radiobutton'
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchData, fetchDatasearch, fetchDatasearch2, orgneeds } from '../reduxactions/donorrsactions/NewDonationAction';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from 'react-router-dom';
import './NewDonation.css';


import { Toast } from 'primereact/toast';
import { LoginService } from '../services/LoginService';
import { donorapi } from '../ApiNames';
import { GFNButton } from '../ui';


var imageName = require('./../assets/images/user.png')
var imageuser = require('../assets/images/images.png');


interface NeedData {
    Id: string; // Change the type accordingly
    needtype: string; // Change the type accordingly
}
const NewDonation = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        const storedCatId = sessionStorage.getItem('catid');
        const storedFirstName = sessionStorage.getItem('firstname');
        const storedLocation = sessionStorage.getItem('location');

        if (storedCatId !== null && storedCatId !== 'undefined') {
            setNeedIds(storedCatId);
        }

        if (storedFirstName !== null && storedFirstName !== 'undefined') {
            setNames(storedFirstName);
        }

        if (storedLocation !== null && storedLocation !== 'undefined') {
            setLocations(storedLocation);
        }
    }, []);
    const [needIds, setNeedIds] = useState('');
    const [orgnames, setNames] = useState('');
    const [locations, setLocations] = useState('');

    const [datas, setData] = useState<NeedData[]>([]);
    const [selectedNeed, setSelectedNeed] = useState<NeedData | null>(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [needId, setNeedId] = useState('');
    const [orgname, setName] = useState('');
    const [location, setLocation] = useState('');
    const [needstype, setNeedstype] = useState('needs'); // Assuming 'Needs' is the initial value

    const data = useSelector((state: RootState) => state.newdonationreducer.data);
    const dataview = useSelector((state: RootState) => state.newdonationreducer.dataview);
    const dataviewed = useSelector((state: RootState) => state.newdonationreducer.dataview2);
    const dataviewed1 = useSelector((state: RootState) => state.newdonationreducer.dataview3);


    window.sessionStorage.setItem('catid', String(needId));
    window.sessionStorage.setItem('firstname', orgname);
    window.sessionStorage.setItem('location', location);

    const uid = window.sessionStorage.getItem('uid');
    const userid = window.sessionStorage.getItem('userid');
    const Locationsurls = window.sessionStorage.getItem('Locationsurls');
    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const org = async () => {
        try {
            await dispatch(orgneeds(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }

    // To get data
    const toast = useRef<Toast>(null);
    const [needsSerchedData, setNeedSearchedData] = useState<[]>([])
    const fetchDataAsyncearch = async () => {
        // if (!selectedNeed) {
        //     toast.current?.show({
        //         severity: 'warn',
        //         detail: 'You need to first select need',
        //         life: 3000,
        //     });
        // }
        try {
            let catIds;
            let firstnames;
            let locationss;
            if (sessionStorage.getItem('catid') !== null) {
                const catIds = window.sessionStorage.getItem('catid');
            }
            if (sessionStorage.getItem('firstname') !== null) {
                const firstnames = window.sessionStorage.getItem('firstname');
            }
            if (sessionStorage.getItem('location') !== null) {
                const locationss = window.sessionStorage.getItem('location');
            }
            const payload = { userid: uid, needtype: selectedNeed, name: orgname, location: location, type: "needs" }
            const apiname = donorapi.search;
            const response = await LoginService.getData(apiname, payload);
            setNeedSearchedData(response)
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const onNeedTypeChange = (value: 'needs' | 'org') => {
        setNeedstype(value);
        // 🔥 RESET STATES
        setSelectedNeed(null);
        setName('');
        setLocation('');
        setOrgSearchedData([]);
    };
    const [orgSerchedData, setOrgSearchedData] = useState<[]>([])
    const fetchOrgNeedsData = async () => {
        // if (!selectedNeed) {
        //     toast.current?.show({
        //         severity: 'warn',
        //         detail: 'You need to first select need',
        //         life: 3000,
        //     });
        //     return
        // }
        try {
            let catIds;
            let firstnames;
            let locationss;
            if (sessionStorage.getItem('catid') !== null) {
                const catIds = window.sessionStorage.getItem('catid');
            }
            if (sessionStorage.getItem('firstname') !== null) {
                const firstnames = window.sessionStorage.getItem('firstname');
            }
            if (sessionStorage.getItem('location') !== null) {
                const locationss = window.sessionStorage.getItem('location');
            }
            const payload = { userid: uid, needtype: selectedNeed, name: orgname, location: location, type: "org" }
            const apiname = donorapi.search;
            const response = await LoginService.getData(apiname, payload);
            setOrgSearchedData(response)
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffect(() => {
        fetchDataAsync();
        org();
    }, [dispatch])



    useEffect(() => {
        if (needstype === 'needs') {
            fetchDataAsyncearch();
        }
    }, [needstype])



    const viewuploaddata = async () => {
        try {
            await dispatch(fetchDatasearch(uid, selectedNeed, orgname, location, needstype) as any);
        } catch (error) {
            const viewdonor = async (rowData: any) => {
                // const { Id } = rowData.Id
                // const url = `/donation/${rowData.orgID}/${rowData.need}/${userid}/${rowData.needid}/${Locationsurls}`;
                const url = `/donation/${userid}/${rowData.orgID}/${rowData.needid}`;
                console.log('Row ID:', rowData.Id);
                // Use navigate to navigate to the URL
                navigate(url);
            }

            //To disable search button
            console.error('Error fetching data', error)
        }
    }

    const navigate = useNavigate();

    const viewuploadneeddata = async (rowData: any) => {
        const url = `/needsview/${rowData.Id}/${rowData.needtypeid}`;
        console.log('Row ID:', rowData.Id);
        // Use navigate to navigate to the URL
        navigate(url);
    }
    // https://devapi.gearforneed.com/member/gfn-api/ws_ifdonation.php?orgid=912&needtype=&userid=469&needid=undefined&liveurl=https://devang.gearforneed.com

    const viewdonor = async (rowData: any) => {
        // const { Id } = rowData.Id
        // const url = `/donation/${rowData.orgID}/${rowData.need}/${userid}/${rowData.needid}/${Locationsurls}`;
        //const url = `/donation/${userid}/${rowData.orgID}/${rowData.needid}`;
        const url = `/needsview/${rowData.orgneedid}/${rowData.needid}`;
        console.log('orgID:', rowData.orgID);
        console.log('needid:', rowData.needid);


        console.log('Row ID:', rowData.Id);
        // Use navigate to navigate to the URL
        navigate(url);
    }

    //To disable search button
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">New Donation</h1>
                            </div>
                            {/* <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a> */}
                        </section>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="grid">
                                    <div className="col-12">
                                        <Card>
                                            <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '10px' }}>Show:</label>
                                                <div className="flex flex-wrap gap-3">
                                                    <div className="flex align-items-center">
                                                        <RadioButton inputId="ingredient1" data-testid="needs-radio" name="pizza" value="needs" onChange={(e) => onNeedTypeChange(e.value)} checked={needstype === 'needs'} />
                                                        <label htmlFor="ingredient1" className="ml-2">Needs</label>
                                                    </div>
                                                    <div className="flex align-items-center">
                                                        <RadioButton inputId="ingredient2" data-testid="org-radio" name="pizza" value="org" onChange={(e) => onNeedTypeChange(e.value)} checked={needstype === 'org'} />
                                                        <label htmlFor="ingredient2" className="ml-2">Organization</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                                {needstype === 'needs' && (
                                    <Panel header="Needs">
                                        <div className="grid align-items-end">

                                            {/* Need Type */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Need Type
                                                </label>
                                                <Dropdown
                                                    value={selectedNeed}
                                                    data-testid="need-needtype-select"
                                                    options={data}
                                                    optionLabel="needtype"
                                                    optionValue="Id"
                                                    placeholder="Select a Need"
                                                    style={{ textAlign: 'left' }}
                                                    className="w-full"
                                                    onChange={(e) => setSelectedNeed(e.value)}
                                                />
                                            </div>

                                            {/* Organization Name */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Organization Name
                                                </label>
                                                <InputText
                                                    data-testid="needs-orgname-input"
                                                    placeholder="Organization Name"
                                                    className="w-full"
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>

                                            {/* Organization Location */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Organization Location
                                                </label>
                                                <InputText
                                                    placeholder="Organization Location"
                                                    data-testid="needs-location-input"
                                                    className="w-full"
                                                    onChange={(e) => setLocation(e.target.value)}
                                                />
                                            </div>

                                            {/* Search Button */}
                                            <div className="col-12 md:col-6 lg:col-3 flex align-items-end">
                                                <Button
                                                    icon="pi pi-search"
                                                    data-testid="needs-search-btn"
                                                    label="Search"
                                                    className="p-button-sm"
                                                    onClick={fetchDataAsyncearch}
                                                />
                                            </div>

                                        </div>
                                    </Panel>
                                )}
                                {needstype === 'org' && (
                                    <Panel header="Organisation">
                                        <div className="grid align-items-end">

                                            {/* Need Type */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Need Type
                                                </label>
                                                <Dropdown
                                                    value={selectedNeed}
                                                    data-testid="org-needtype-select"
                                                    options={data}
                                                    optionLabel="needtype"
                                                    optionValue="Id"
                                                    placeholder="Select a Need"
                                                    style={{ textAlign: 'left' }}
                                                    className="w-full"
                                                    onChange={(e) => setSelectedNeed(e.value)}
                                                />
                                            </div>

                                            {/* Organization Name */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Organization Name
                                                </label>
                                                <InputText
                                                    placeholder="Organization Name"
                                                    data-testid="org-orgname-input"
                                                    className="w-full"
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>

                                            {/* Organization Location */}
                                            <div className="col-12 md:col-6 lg:col-3">
                                                <label className="block mb-2 font-medium text-left">
                                                    Organization Location
                                                </label>
                                                <InputText
                                                    placeholder="Organization Location"
                                                    data-testid="org-orglocation-input"
                                                    className="w-full"
                                                    onChange={(e) => setLocation(e.target.value)}
                                                />
                                            </div>

                                            {/* Search Button */}
                                            <div className="col-12 md:col-6 lg:col-3 flex align-items-end">
                                                <Button
                                                    icon="pi pi-search"
                                                    data-testid="org-search-btn"
                                                    label="Search"
                                                    className="p-button-sm"
                                                    onClick={fetchOrgNeedsData}
                                                />
                                            </div>

                                        </div>
                                    </Panel>
                                )}


                            </div >
                        </section >

                        <section className="content">
                            <div className="container-fluid">
                                <div className="grid">
                                    {orgSerchedData.length > 0 && orgSerchedData.map((response: any) => (
                                        <div key={response.id} className="col-12 sm:col-6 md:col-4 lg:col-3">
                                            <Card style={{ marginTop: '12px', padding: 0 }}>

                                                {/* Header */}
                                                <div
                                                    style={{
                                                        backgroundColor: '#ffc107',
                                                        padding: '30px 20px 20px',
                                                        textAlign: 'center',
                                                        borderTopLeftRadius: '6px',
                                                        borderTopRightRadius: '6px',
                                                        minHeight: '240px',   // 🔑 ensures same height always
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            response.photo === '' ||
                                                                response.photo?.trim().endsWith('/uploads/content/gfn/profile/')
                                                                ? imageName
                                                                : response.photo
                                                        }
                                                        alt="Organisation Logo"
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            borderRadius: '50%',
                                                            objectFit: 'cover',
                                                            border: '4px solid #fff',
                                                            marginBottom: '15px',
                                                        }}
                                                    />

                                                    <h4 style={{ margin: 0, fontWeight: '700', color: '#212529' }}>
                                                        {response.nameoftheorg}
                                                    </h4>

                                                    <div style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        Organization
                                                    </div>
                                                </div>


                                                {/* Need Type row (only for needs) */}
                                                <div

                                                    style={{

                                                        display: 'flex',

                                                        alignItems: 'center',

                                                        justifyContent: 'space-between',

                                                        padding: '10px 16px',

                                                    }}
                                                >
                                                    <span style={{ fontWeight: '600', color: '#495057' }}>

                                                        Need Type
                                                    </span>

                                                    <span

                                                        style={{

                                                            backgroundColor: '#0d6efd',

                                                            color: '#fff',

                                                            padding: '4px 10px',

                                                            borderRadius: '6px',

                                                            fontSize: '13px',

                                                            fontWeight: '600',

                                                        }}
                                                    >

                                                        {response.need}
                                                    </span>
                                                </div>

                                                <div

                                                    style={{

                                                        height: '1px',

                                                        backgroundColor: '#dee2e6',

                                                        width: '100%',

                                                    }}

                                                />

                                                {/* Profile row */}
                                                <div

                                                    style={{

                                                        display: 'flex',

                                                        alignItems: 'center',

                                                        justifyContent: 'space-between',

                                                        padding: '12px 16px',

                                                    }}
                                                >
                                                    <span style={{ fontWeight: '600', color: '#212529' }}>

                                                        Profile
                                                    </span>

                                                    <button className="p-button p-button-primary p-button-sm" data-testid="view-donor-btn" onClick={() => viewdonor(response)}>

                                                        Select
                                                    </button>
                                                </div>

                                            </Card>
                                        </div>

                                    ))}



                                    <div className="col-12">

                                        {needstype === 'needs' && (
                                            <Panel header="List" style={{ padding: "10px" }}>
                                                <div className=''>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-right m-2">
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <DataTable value={needsSerchedData} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                                                        <Column field="needtype" sortable header="Need Type"></Column>
                                                        <Column header="Description" body={(rowData) => (
                                                            <span>{rowData.needtittle}<br />{rowData.description}</span>

                                                        )}></Column>
                                                        <Column field="budget_amount" sortable header="Budget Amount"></Column>
                                                        <Column field="required_amount" sortable header="Required Amount"></Column>
                                                        <Column field="status" sortable header="Status"></Column>

                                                        <Column header="Option" body={(rowData, { rowIndex }) => (
                                                            <div>
                                                                {/* <Button className='mr-1' data-testid={`view-btn-${rowIndex}`} severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewuploadneeddata(rowData)} /> */}
                                                                <GFNButton  icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} rounded outlined onClick={() => viewuploadneeddata(rowData)} buttonType="primary" />
                                                                {/* <Button className='mr-1' severity="info" icon="pi pi-arrow-right-arrow-left" rounded outlined onClick={() => viewdonor(rowData)} /> */}
                                                            </div>
                                                        )}></Column>
                                                    </DataTable>
                                                </div>
                                            </Panel>

                                        )}

                                    </div >
                                </div >
                            </div >
                        </section >
                    </div >
                </div>
            </div>
            <Toast ref={toast} />

        </div>

    )

}

export default NewDonation
